<template>
  <main class="main-content" id="topDom">
    <section class="section">
      <div class="banner">
        <div class="banner__bg">
          <img :src="imgUrl" />
        </div>
        <div class="banner__content container-fluid">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <p class="banner__text" v-html="$t('i18n.contactUsText')"></p>
              <p class="banner__text" style="font-size: 3rem;" v-html="$t('i18n.contactUsTexts')"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="header-footer container-fluid">
        <div
          class="header-footer-card"
          v-for="(item, index) of $t('i18n.contactUsList')"
          :key="index"
          :class="{ 'header-footer-main': index === 1 }"
        >
          <!--            <div class="container-fluid">-->
          <div class="card">
            <div class="title">
              {{ item.title }}
              <span>{{ item.titleText }}</span>
            </div>
            <div class="card-text --user" data-after="user">
              {{ item.name }}
            </div>
            <div class="card-text --phone" data-after="phone">
              {{ item.phone }}
            </div>
            <div class="card-text --email" data-after="email" v-if="item.email">
              {{ item.email }}
            </div>
            <div class="card-text --address" data-after="address">
              {{ item.address }}
            </div>
          </div>
          <!--            </div>-->
        </div>
      </div>
    </section>

    <section class="section form" id="form">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-3">
            <h2 style="font-size: 32px;font-weight: 500;">{{ $t('i18n.leaveUsMessage') }}</h2>
          </div>
          <div class="col-12 col-md-8 ml-0 ml-md-auto mt-2 mt-md-0">
            <p class="mb-3 mb-md-5 title-p">
              {{ $t('i18n.leaveUsMessages') }}
            </p>
            <form>
              <div class="row">
                <div class="col-12 col-md-3">
                  <div class="form-group --required">
                    <label>{{ $t('i18n.call') }}</label>
                    <span class="invalid-feedback" v-if="checkText('nickname', 'text')">{{ $t('i18n.pleaseChoose') }}</span>
                    <div class="classic-selectbox --invalid">
                      <div class="classic-selectbox__vue-select">
                        <div class="classic-selectbox__selected-item" @click="showSelect = !showSelect" ref="s1">
                          <span>{{ !form.nickname ? $t('i18n.choose') : form.nickname }}</span>
                        </div>
                        <div class="classic-selectbox__item-list" v-show="showSelect">
                          <ul class="classic-selectbox__item-list-inner">
                            <li class="classic-selectbox__item disabled" >
                              {{ $t('i18n.choose') }}
                            </li>
                            <li class="classic-selectbox__item" v-for="(item, index) in $t('i18n.select_list')" @click="choseItem(item.name)" >
                              {{ item.name }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-group --required">
                    <label>{{ $t('i18n.name') }}</label>
                    <span class="invalid-feedback" v-if="checkText('familyname', 'text')">{{ $t('i18n.notEmpty') }}</span>
                    <input type="text" class="form-input" name="familyname" v-model="form.familyname">
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group --required">
                    <label>{{ $t('i18n.lastname') }}</label>
                    <span class="invalid-feedback" v-if="checkText('firstname', 'text')">{{ $t('i18n.notEmpty') }}</span>
                    <input type="text" class="form-input" name="firstname" v-model="form.firstname">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label>{{ $t('i18n.dept') }}</label>
                    <input type="text" class="form-input" name="company" v-model="form.company">
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label>{{ $t('i18n.department') }}</label>
                    <input type="text" class="form-input" name="major" v-model="form.major">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-group --required --invalid">
                    <label>{{ $t('i18n.emailC') }}</label>
                    <span class="invalid-feedback" v-if="checkText('email', 'email')"> {{ $t('i18n.emailText') }}</span>
                    <input type="email" class="form-input" name="email" v-model="form.email">
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group --required ">
                    <label>{{ $t('i18n.phone') }}</label>
                    <span class="invalid-feedback" v-if="checkText('mobile', 'text')">{{ $t('i18n.notEmpty') }}</span>
                    <input type="email" class="form-input" name="mobile" v-model="form.mobile">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-group --required">
                    <label>{{ $t('i18n.CountryRegion') }}</label>
                    <span class="invalid-feedback" v-if="checkText('country', 'text')">{{ $t('i18n.pleaseChoose') }}</span>
                    <div class="classic-selectbox --search --invalid">
                      <div class="classic-selectbox__vue-select">
                        <div class="classic-selectbox__selected-item" @click="showNational = !showNational">
                          <span>{{ !form.country ? $t('i18n.CountryRegion') : form.country }}</span>
                        </div>
                        <div class="classic-selectbox__item-list" v-show="showNational">
<!--                          <div class="classic-selectbox__searchbox-wrapper">-->
<!--                            <input class="classic-selectbox__searchbox" type="text" v-model="searchValue" @change="selectNational">-->
<!--                          </div>-->
                          <ul class="classic-selectbox__item-list-inner">
                            <li class="classic-selectbox__item disabled"> {{ $t('i18n.CountryRegion') }} </li>
                            <li class="classic-selectbox__item" :class="{ disabled: form.country === item.value }" v-for="(item, index) of nationalNameList" @click="selectNational(item)">
                              {{ item.value }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label>{{ $t('i18n.Topic') }}</label>
                    <input type="email" class="form-input" name="title" v-model="form.title">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group --required">
                    <span class="invalid-feedback" v-if="checkText('content', 'text')">{{ $t('i18n.notEmpty') }}</span>
                    <label>{{ $t('i18n.YourMessage') }}</label>
                    <textarea name="content" class="form-input" v-model="form.content">
                    </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="fancy-file-upload__wrapper" data-validation="file">
                      <label class="fancy-file-upload mb-0">
                        <input name="file" type="file" @change="uploadFile" accept=".png, .jpg, .cad, .pdf">
                        <span>{{ $t('i18n.UploadFiles') }}</span>
                      </label>
                      <div class="fancy-file-upload__file" style="display: none;">
                        <span></span>
                        <div class="fancy-file-upload__remove">

                        </div>
                      </div>
                      <span class="fancy-file-upload__text">{{ $t('i18n.cText') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-7">
                  <div class="form-group mb-2 --recapcha">
                    <div class="g-recaptcha" data-size="normal" data-theme="light" id="recaptcha-element">

                    </div>
                  </div>
                  <div class="form-group mb-2 mb-md-0">
                    <label class="checkbox">
                      <span class="invalid-feedback --check" v-if="checkText('check', 'check')">{{ $t('i18n.notEmpty') }}</span>
                      <input type="checkbox" name="privacy_policy" value="1" class="checkbox__input" v-model="check">
                      <span class="checkbox__checkmark"></span>
                      <span class="checkbox__label">{{ $t('i18n.cText2') }}</span>
                    </label>
                  </div>
                </div>
                <div class="col-12 col-md-4 ml-auto text-right">
                  <button type="button" class="btn --primary w-100 w-md-auto d-flex d-md-inline-flex" @click="submit">{{ $t('i18n.sendMessage') }}</button>
                </div>
              </div>
            </form>
          </div>
        </div>

          <div class="row mt-4 mt-md-2">
            <div class="col-6" style="cursor: pointer !important; " >
              <div class="white-box__links">
                <a class="white-box__link" @click="toPage('about')">
                  <strong class="white-box__link-label">
                    {{ $t("i18n.company") }}
                  </strong>
                  <h4 class="white-box__link-text">
                    {{ $t("i18n.about") }}
                  </h4>
                </a>
                <a class="white-box__link" @click="toPage('CareerOpportunities')">
                  <strong class="white-box__link-label">
                    {{ $t("i18n.company") }}
                  </strong>
                  <h4 class="white-box__link-text">
                    {{ $t("i18n.CareerOpportunities") }}
                  </h4>
                </a>
              </div>
            </div>
          </div>
      </div>
    </section>
  </main>
</template>

<script>
import nationalNameCh from "../assets/js/nationalNameCh";
import { upload, userFeedback } from "../api/api";
import {Message} from "element-ui";
export default {
  name: "contactUs",
  data() {
    return {
      imgUrl: this.isMobile() ? require("../assets/imgs/contactUsBg-p.png") : require("../assets/imgs/contactUsBg.png"),
      nationalNameCh: nationalNameCh,
      nationalNameList: [],
      showSelect: false,
      showNational: false,
      requireForm: {
        nickname: "",
        familyname: "",
        firstname: "",
        mobile: "",
        email: "",
        country: "",
        content: "",
      },
      form: {
        nickname: "",
        familyname: "",
        firstname: "",
        company: "",
        major: "",
        mobile: "",
        email: "",
        country: "",
        title: "",
        content: "",
        file: "",
      },
      isValidate: false,
      searchValue: "",
      check: false,

    };
  },
  created() {
    this.nationalNameList =  JSON.parse(JSON.stringify(this.nationalNameCh))
  },
  mounted() {
    this.goTop();
    document.addEventListener(
      "click",
      (e) => {
        let s1 = this.$refs.s1;
        if (!s1.contains(e.target)) {
          this.showSelect = false;
        }
      },
      true
    );
  },
  methods: {
    uploadFile(event) {
      let file = event.target.files[0];
      const formData = new FormData();
      formData.append('file', file);

      upload(formData).then(res => {
        if (res.data && res.data.code) {
          this.form.file = res.data.file;
          Message({
            message: this.$t('i18n.uploadSuccess'),
            // message: error.message,
            type: 'success',
            duration: 3 * 1000
          });
        } else {
          this.from.file = "";
          Message({
            message: res.data.msg,
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
        }
      });
    },
    toPage(path) {
      this.$router.push(path)
    },
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    goPage(path) {
      this.$router.push(path);
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: "smooth" }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    },
    choseItem(val) {
      this.form.nickname = val;
    },
    submit() {
      this.isValidate = true;
      let flg = false;
      for (let fileId in this.requireForm) {
        if (fileId === 'email') {
          flg = this.checkText(fileId, 'email');
        } else if (fileId === 'check') {
          flg = this.checkText(fileId, 'check');
        } else {
          flg = this.checkText(fileId, 'text');
        }
        if (flg) {
          break;
        }
      }
      if (!flg && this.check) {
        userFeedback(this.form).then(res => {
          this.isValidate = false;
          if (res.data && res.data.code) {
            Message({
              message: this.$store.state.language === '中文' ? '发送成功' : "Sent successfully",
              // message: error.message,
              type: 'success',
              duration: 3 * 1000
            });
            this.form = {}
            this.goTop();
          } else {
            Message({
              message: res.data.msg,
              // message: error.message,
              type: 'error',
              duration: 3 * 1000
            });
          }
        });
      }
    },
    selectNational(item) {
      this.form.country = item.value;
      this.showNational = false;
    },
    checkText(fileId, type) {
      if (!this.isValidate) {
        return false;
      }
      if (type === 'text') {
        return !this.form[fileId];
      } else if (type === 'email') {
        const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
        return !emailPattern.test(this.form.email);
      } else if (type === 'check') {
        return !this.check;
      }
    },
  },
};
</script>

<style scoped>
.banner {
  height: 61rem;
  align-items: center;
  display: flex;
}
.banner__bg {
  position: absolute;
  width: 100%;
  height: 61rem;
}
.banner__bg {
  z-index: 1;
}
.banner__bg img {
  max-width: 100%;

  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%;
}

.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-weight: 300;
  font-size: 3.2rem;
  color: #fff;
  letter-spacing: -0.084rem;
  line-height: 6rem;
}
.banner__text {
  margin-top: 3rem;
  font-size: 4rem;
  font-weight: 500;
  color: #fff;
  letter-spacing: -0.022rem;
  /* line-height: 5rem; */
  padding-right: 2rem;
}

.header-footer {
  margin-right: 0;
  margin-left: 0;
  padding: 0;
  max-width: 100%;
  display: flex;
}
.header-footer-card {
  width: 100%;
  height: 20rem;
  background-color: #5a246b;
  border-right: 0.1rem solid #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card {
  width: 30rem;
  text-align: left;
  padding-top: 2rem;
  color: white;
}

.title {
  font-size: 2.4rem;
  font-weight: normal;
  color: #ffffff;
  line-height: 3rem;
  border-bottom: 0.1rem solid #999999;
  margin-bottom: 1rem;
}

.title span {
  font-size: 1.4rem;
  font-weight: normal;
}
.card-text {
  font-size: 1.4rem;
  font-weight: normal;
  color: #ffffff;
}
.card-text.--user:before {
  content: "";
  padding-right: 2rem;
  width: 0.8rem;
  height: 1.4rem;
  background: url(../assets/imgs/user.png) no-repeat 50%;
  transition: all 0.2s ease-in-out;
}

.card-text.--phone:before {
  content: "";
  padding-right: 2rem;
  width: 0.8rem;
  height: 1.4rem;
  background: url(../assets/imgs/phone.png) no-repeat 50%;
  transition: all 0.2s ease-in-out;
}
.card-text.--email:before {
  content: "";
  padding-right: 2rem;
  width: 0.8rem;
  height: 1.4rem;
  background: url(../assets/imgs/email.png) no-repeat 50%;
  transition: all 0.2s ease-in-out;
}
.card-text.--address:before {
  content: "";
  padding-right: 2rem;
  width: 0.8rem;
  height: 1.4rem;
  background: url(../assets/imgs/address.png) no-repeat 50%;
  transition: all 0.2s ease-in-out;
}
.form-group {
  position: relative;
  margin-bottom: 4rem;
}
.form-label,
label {
  display: flex;
  font-weight: 600;
  font-size: 1.4rem;
  letter-spacing: 0.035rem;
  color: #000;
  line-height: 1.7rem;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
}
.form-group.--required .form-label:before,
.form-group.--required label:before {
  content: "";
  width: 0.6rem;
  height: 0.6rem;
  background: url(../assets/imgs/required.svg) no-repeat 50%;
  margin-right: 1rem;
  margin-top: 0.6rem;
}
.classic-selectbox__vue-select {
  position: relative;
}
.classic-selectbox__selected-item,
select {
  display: flex;
  align-items: center;
  width: 100%;
  border: 0.1rem solid #e6e6e6;
  height: 6rem;
  padding: 0 2.5rem;
  font-size: 1.8rem;
  color: #4c4c4c;
  cursor: pointer;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  background: url(../assets/imgs/select-arrow.png) no-repeat #fff center right
    2rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.06);
  border-radius: 0.4rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-sizing: border-box;
  transition-property: all;
  transition-duration: 0.3s;
  transition-property: background-color, box-shadow, color;
}
.classic-selectbox__item-list {
  position: absolute;
  z-index: 950;
  top: calc(100% + 0.2rem);
  width: 100%;
  min-width: 29rem;
  border: 0.1rem solid #e6e6e6;
  left: 0;
  background: #fff;
  transform: translateY(0);
  border-radius: 0.4rem;
  box-shadow: 0 2rem 4rem 0 rgba(0, 0, 0, 0.1);
  transition-property: all;
  transition-duration: 0.3s;
  box-sizing: border-box;
}
.classic-selectbox__item-list-inner {
  max-height: 30rem;
  overflow: auto;
  position: relative;
  z-index: 2;
  border-radius: 0.4rem;
}
.classic-selectbox__item {
  height: 6rem;
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0 2.5rem;
  color: #4c4c4c;
  font-size: 1.8rem;
  cursor: pointer;
  transition-property: all;
  transition-duration: 0.3s;
}
.classic-selectbox__item.disabled {
  color: #ccc;
  pointer-events: none;
}
.classic-selectbox__item.is-active,
.classic-selectbox__item:hover {
  background-color: #fafafa;
  color: #5a246b;
}

.invalid-feedback {
  height: 1.8rem;
  color: #fff;
  top: 0;
  right: 0;
  position: absolute;
  display: inline-block;
  background: #d0021b;
  font-size: 1.4rem;
  text-transform: none !important;
  line-height: 1.7rem;
  font-weight: 600;
  padding: 0 0.5rem;
  border-radius: 0.3rem;
}

.invalid-feedback.--check {
  top: 3rem;
}
.form-input, input[type=email], input[type=text] {
  width: 100%;
  height: 6rem;
  padding: 0 2.5rem;
  font-size: 1.8rem;
  color: #000;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  border: .1rem solid #e6e6e6;
  border-radius: .4rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transition-property: all;
  transition-duration: .3s;
}
.classic-selectbox__selected-item, select {
  display: flex;
  align-items: center;
  width: 100%;
  border: .1rem solid #e6e6e6;
  height: 6rem;
  padding: 0 2.5rem;
  /* font-size: 1.8rem; */
  font-size: 1.3rem;
  font-weight: bold;
  color: #4c4c4c;
  cursor: pointer;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  background: url(../assets/imgs/select-arrow.png) no-repeat #fff center right 2rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0,0,0,.06);
  border-radius: .4rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-sizing: border-box;
  transition-property: all;
  transition-duration: .3s;
  transition-property: background-color, box-shadow, color;
}
.classic-selectbox.--search .classic-selectbox__item-list {
  overflow: hidden;
  top: 6.5rem;
}
.classic-selectbox__item-list .classic-selectbox__searchbox {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  padding-left: 6rem;
  width: 100% !important;
  border-radius: 0;
}
.classic-selectbox__item-list-inner {
  max-height: 30rem;
  overflow: auto;
  position: relative;
  z-index: 2;
  border-radius: .4rem;
}
.classic-selectbox__item.disabled {
  color: #ccc;
  pointer-events: none;
}
.classic-selectbox__item {
  height: 6rem;
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0 2.5rem;
  color: #4c4c4c;
  font-size: 1.8rem;
  cursor: pointer;
  transition-property: all;
  transition-duration: .3s;
}
.form-input:focus, .form-input:hover, input[type=email]:focus, input[type=email]:hover, input[type=text]:focus, input[type=text]:hover {
  outline: none;
  border-color: #d9d9d9;
  background-color: #fafafa;
}
.classic-selectbox__item-list .classic-selectbox__searchbox-wrapper:before {
  content: "";
  width: 3rem;
  height: 3rem;
  position: absolute;
  z-index: 2;
  background: url(../assets/imgs/searchImg.png) 50% no-repeat;
  top: 8%;
  left: 2rem;
  transform: translateY(-50%);
}
textarea {
  resize: none;
  height: 12rem !important;
  padding: 2rem 2.5rem !important;
}
.fancy-file-upload {
  position: relative;
  display: flex;
  cursor: pointer;
  height: 6rem;
  background: #fff;
  align-items: center;
  padding: 0 3rem;
  letter-spacing: -.02rem;
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: #5a246b;
  font-weight: 600;
  text-transform: none;
  border: .1rem solid #e6e6e6;
  border-radius: .4rem;
  transition-property: all;
  transition-duration: .3s;
}
.fancy-file-upload input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  pointer-events: none;
  filter: alpha(opacity = 0);
  -moz-opacity: 0;
  -khtml-opacity: 0;
  opacity: 0;
}
.fancy-file-upload:after {
  content: "";
  width: 3rem;
  height: 3rem;
  margin-left: auto;
  background: #5a246b;
  -webkit-mask: url(../assets/imgs/upload.png) no-repeat center;
  mask: url(../assets/imgs/upload.png) no-repeat center;
  transition-property: all;
  transition-duration: .3s;
}
.fancy-file-upload:hover {
  border-color: #5a246b;
  background: #5a246b;
  color: #fff;
}
.fancy-file-upload:hover:after {
  background: #fff;
}
.checkbox {
  min-height: 2rem;
  width: 100%;
  display: flex;
  margin-bottom: 0;
  align-items: top;
}
.checkbox__input {
  position: absolute;
  filter: alpha(opacity = 0);
  -moz-opacity: 0;
  -khtml-opacity: 0;
  opacity: 0;
}

.checkbox__input:checked~.checkbox__checkmark {
  background: url(../assets/imgs/icon-check-white.svg) #990099 no-repeat 50%;
  border-color: #990099;
}
.checkbox__checkmark {
  display: block;
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  margin-top: .2rem;
  margin-right: 1.5rem;
  background: 50% #fff;
  border: .1rem solid #e6e6e6;
  border-radius: .4rem;
  box-sizing: border-box;
  transition-property: all;
  transition-duration: .3s;
}
.checkbox__label {
  display: block;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  line-height: 2.4rem;
  text-transform: none;
  font-weight: 500;
  color: #4c4c4c;
  letter-spacing: -.009rem;
  width: calc(100% - 3.5rem);
}
.btn {
  display: flex;
  width: 100%;
  align-items: center;
  height: 6rem;
  position: relative;
  border: 0;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: .4rem;
  transition: all .2s ease-in-out;
}
.btn.--primary {
  padding: 0 6.5rem 0 3rem;
  background: #5a246b;
  font-size: 1.6rem;
  font-weight: 600;
  color: #fff;
  letter-spacing: -.02rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0,0,0,.05);
}
.title-p {
  font-size: 2rem;
  margin-top: 2rem;
}
.form {
  margin-top: 10rem;
  margin-bottom: 10rem;
}

.white-box__links {
  position: relative;
  z-index: 2;
  background: #fff;
  border: 0.1rem solid #e6e6e6;
  display: flex;
  min-height: 18rem;
  overflow: hidden;
  border-radius: 0.4rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0,0,0,.05);
  margin-bottom: 3rem;
}
.white-box__link:last-child {
  border: 0 !important;
}
.white-box__link {
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 5rem;
  border-right: 0.1rem solid #e6e6e6;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-label, .white-box__link-label {
  font-weight: 500;
  font-size: 1.3rem;
  color: black;
  letter-spacing: .035rem;
  text-transform: uppercase;
  display: block;
  line-height: 1.7rem;
  margin-bottom: 1rem;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text, .white-box__link-text {
  font-weight: 500;
  font-size: 3rem;
  color: #990099;
  letter-spacing: -.015rem;
  line-height: 3.2rem;
  position: relative;
  padding-right: 1.5rem;
  margin: 0;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text:after, .white-box__link-text:after {
  content: "";
  position: absolute;
  padding-right: 2rem;
  right: 0;
  width: 0.8rem;
  height: 1.4rem;
  top: 1.2rem;
  background: url(../assets/imgs/arrow-right.png) no-repeat 50%;
  transition: all .2s ease-in-out;

}

.fancy-file-upload__text {
  font-size: 13px;
  font-weight: 500;  
}
@media (max-width: 1023.9px) {
  .header-footer-card {
    display: block;
    height: auto;
  }
  .header-footer {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/contactUs.vue